import { createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { notifications } from "@mantine/notifications";
import { IconX } from "@tabler/icons-react";
import Cookies from "js-cookie";
import { environment } from "../../constants/environment";

export const httpLink = createHttpLink({
  uri: `${environment.BACKEND_URL}/graphql`,
});

export const authLink = setContext((_, { headers }) => {
  // Get the authentication token from cookies for each request
  const token = Cookies.get("jwt");

  return {
    headers: {
      ...headers,
      Authorization: token || "",
    },
  };
});

export const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );

        notifications.show({
          title: "Error",
          message: message || "An unexpected error occurred",
          color: "red",
          icon: <IconX size={16} />,
          autoClose: 5000,
        });
      });
    }

    if (networkError) {
      console.error(`[Network error]: ${networkError}`);

      notifications.show({
        title: "Network Error",
        message:
          "Unable to connect to the server. Please check your connection.",
        color: "red",
        icon: <IconX size={16} />,
        autoClose: 5000,
      });
    }
  }
);
